import type { Resource } from '../../';
export const product_sizeChart_measurements_us: Resource = {"default":"US"};
